"use client";

import { MotionConfig } from "framer-motion";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useState, useEffect } from "react";

import { Toaster } from "@/components/ui/Toaster";
import { useUIStore } from "@/store/uiStore";

function ThemeSync() {
  const setSystemTheme = useUIStore((s) => s.setSystemTheme);

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return;

    const mq = window.matchMedia("(prefers-color-scheme: dark)");
    const handle = (e: MediaQueryListEvent | MediaQueryList) => {
      setSystemTheme(e.matches ? "dark" : "light");
    };

    handle(mq);
    mq.addEventListener("change", handle as EventListener);
    return () => mq.removeEventListener("change", handle as EventListener);
  }, [setSystemTheme]);

  return null;
}

export default function Providers({ children }: { children: React.ReactNode }) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 60 * 1000, // 1 minute
            retry: 1,
            refetchOnWindowFocus: false,
          },
        },
      })
  );

  return (
    <QueryClientProvider client={queryClient}>
      <MotionConfig reducedMotion="user">
        {children}
        <Toaster />
        <ThemeSync />
      </MotionConfig>
    </QueryClientProvider>
  );
}
